export default __webpack_public_path__ + "media/images/compaigns/transfer-68f2aaf8d36132b38f6e1b321f02f0c8.jpg";